module.exports = __webpack_public_path__ + "static/media/trucos_checked.a2174899.svg";